<script setup lang="ts">
import {useStore} from "../store";
import {defineProps, reactive, onMounted, onUnmounted, watch, defineEmits} from 'vue';
const props = defineProps<{
    startTime?: string
}>()
const emit = defineEmits(["ended"]);
const store = useStore();
const state = reactive({days: 0, hours: 0, minutes: 0, seconds: 0, visible: false})
let CT_TIMER: number | null = null;
const randTime = (Math.floor(Math.random() * 49) + 12) * 1000;
let airTime = new Date(props.startTime as string).getTime() + randTime;

function calculateTime(){
    const currentTime = new Date().getTime();
    if (currentTime > airTime){
        store.updateItemVersion();
        if (CT_TIMER){
            clearInterval(CT_TIMER);
        }
        state.visible = false
        emit("ended")
    }else{
        if (!state.visible){
            state.visible = true
        }
    }

    const secondsLeft = (airTime - currentTime) / 1000;
    state.days = Math.floor(secondsLeft / 86400);
    state.hours = Math.floor((secondsLeft % 86400) / 3600);
    state.minutes = Math.floor(((secondsLeft % 86400) % 3600) / 60);
    state.seconds = Math.floor(((secondsLeft % 86400) % 3600) % 60)
}

onMounted(() => {
    calculateTime()
    CT_TIMER = setInterval(calculateTime, 1000);
})

onUnmounted(() => {
    if (CT_TIMER){
        clearInterval(CT_TIMER);
        state.visible = false
    }
})

watch(() => props.startTime, (startTime) => {
    airTime = new Date(startTime as string).getTime()  + randTime;
})
</script>

<template>
    <div v-if="state.visible" class="flex flex-row font-bold text-center w-full items-stretch text-base mb-2 2xl:mb-4">
        <div class="flex flex-col w-1/4">
            <span class="countdown-amount days">{{ state.days }}</span>
            <span class="text-tf7">DAYS</span>
        </div>
        <div class="flex flex-col w-1/4">
            <span class="countdown-amount hours">{{ state.hours }}</span>
            <span class="text-tf7">HOURS</span>
        </div>
        <div class="flex flex-col w-1/4">
            <span class="countdown-amount minutes">{{ state.minutes }}</span>
            <span class="text-tf7">MINS</span>
        </div>
        <div class="flex flex-col w-1/4">
            <span class="countdown-amount seconds">{{ state.seconds }}</span>
            <span class="text-tf7">SEC</span>
        </div>
    </div>
</template>

<style scoped>

</style>
